import { Link, useCanGoBack, useRouter } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { Button } from '~shared/shadcn/ui/button';

import { TrialClassesTable } from './trial-class-table';

export const TrialClassListPage = () => {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  return (
    <div className=''>
      {canGoBack ? (
        <Button
          variant={'ghost'}
          className='flex items-center p-2 [&_svg]:size-6'
          disabled={!canGoBack}
          onClick={() => {
            router.history.back();
          }}
        >
          <CircleArrowLeft className='size-6' />
          <h2 className='text-2xl font-semibold'>Trial Students</h2>
        </Button>
      ) : (
        <Link to='/classes' className='flex w-max items-center gap-2'>
          <CircleArrowLeft className='size-6' />
          <h2 className='text-2xl font-semibold'>Trial Students</h2>
        </Link>
      )}

      <div className='mt-4 border-t pt-8'>
        <TrialClassesTable />
      </div>
    </div>
  );
};
